<!-- 租房 -->

<template>
  <div class="container">
    <login-navigator></login-navigator>
    <publish-nav></publish-nav>
    <publish-status :navStatus="navStatus"></publish-status>
    <section class="main">
      <div class="main-content">
        <form action=""> 
          <div class="category">
            <h3>类别</h3>
            <p><span class="title"><span class="neccessary">*</span>出租方式</span>
              <span class="all radio_label"><el-radio label="1">整套出租</el-radio></span>
              <span class="one"><el-radio label="2">单间出租</el-radio></span>
          </p>
          </div>
          <div class="basic">
            <h3>基础信息</h3>
            <p><span class="title"><span class="neccessary">*</span>小区名称</span><input class="name" type="text" name="name"></p>
            <div class="home-des">
              <span class="home-title"><span class="neccessary">*</span>房屋类型</span>
              <div class="home-wrap">
                <div class="room-wrap relative">
                  <input class="room" type="text" name="room">
                  <span class="absolute">室</span>
                </div>
                <div class="hall-wrap relative">
                  <input class="hall" type="text" name="hall">
                  <span class="absolute">厅</span>
                </div>
                <div class="toilet-wrap relative">
                  <input class="toilet" type="text" name="toilet">
                  <span class="absolute">卫</span>
                </div>
                 <div class="area-wrap relative">
                  <input class="area" type="text" name="area">
                  <span class="absolute">m²</span>
                </div>
                <div class="direction-wrap">
                  <select name="direction" id="">
                    <option value="请选择朝向">请选择朝向</option>
                    <option value="东">东</option>
                    <option value="东北">东北</option>
                    <option value="南">南</option>
                    <option value="东南">东南</option>
                    <option value="西">西</option>
                    <option value="西北">西北</option>
                    <option value="西南">西南</option>
                    <option value="北">北</option>
                    <option value="西北">西北</option>
                  </select>
                </div>
                <div class="decoration-wrap">
                  <select name="decoration" id="">
                    <option value="请选择装修情况">请选择装修情况</option>
                    <option value="简单装修">简单装修</option>
                    <option value="毛坯">毛坯</option>
                    <option value="中等装修">中等装修</option>
                    <option value="精装修">精装修</option>
                    <option value="豪华装修">豪华装修</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="floor-wrap">
              <span>楼层</span>
              <div class="floor-des">
                <div class="floorNum relative">
                  <span class="left-absolute">第</span>
                  <input type="text" name="floor">
                  <span class="absolute">层</span>
                </div>
                <div class="floorTotal relative">
                  <span class="left-absolute">共</span>
                  <input type="text" name="totalFloor">
                  <span class="absolute">层</span>
                </div>
                <select name="havefloor" id="">
                  <option value="有/无">有/无</option>
                  <option value="有">有</option>
                  <option value="无">无</option>
                </select>
              </div>
            </div>
            <div class="parking-wrap">
              <span>车位</span>
              <div class="parking-des">
                <select name="hasParking" id="">
                  <option value="有/无">有/无</option>
                  <option value="有">有</option>
                  <option value="无">无</option>
                </select>
              </div>
            </div>
            <div class="money-wrap">
              <span>租金</span>
              <div class="money-des">
                <div class="rent-wrap relative">
                  <input type="text" name="rent">
                  <span class="absolute">元/月</span>
                </div>
              </div>
              <select name="rent-choice" id="">
                  <option value="押一付三">押一付三</option>
                  <option value="押二付一">押一付一</option>
                  <option value="半年付">半年付</option>
                  <option value="年付">年付</option>
              </select>
            </div>
            <div class="fee-wrap">
              <span>租金包含费用</span>
              <div class="fee-des">
                <div class="fee-item"><input type="checkbox">水费</div>
                <div class="fee-item"><input type="checkbox">电费</div>
                <div class="fee-item"><input type="checkbox">燃气费</div> 
                <div class="fee-item"><input type="checkbox">宽带费</div>   
                <div class="fee-item"><input type="checkbox">物业费</div> 
                <div class="fee-item"><input type="checkbox">取暖费</div> 
                <div class="fee-item"><input type="checkbox">停车费</div> 
                <div class="fee-item"><input type="checkbox">有线电视费</div>
              </div>
            </div>
          </div>
          <div class="des">
            <h3>详细信息</h3>
            <p><span class="title"><span class="neccessary">*</span>出租方式</span>
              <span class="only-weekend radio_label"><el-radio label="1">仅周末</el-radio></span>
              <span class="only-workday radio_label"><el-radio label="2">仅工作日</el-radio></span>
              <span class="anytime"><el-radio label="3">随时看房</el-radio></span>
            </p>
            <p><span class="title">最早入住时间</span><input class="startTime" type="text" name="startTime"></p>
            <p><span class="title">宜住人数</span><input class="peopleNum" type="text" name="peopleNum"></p>
            <p><span class="title">标题</span><input class="tit" type="text" name="tit"></p>
          </div>
          <div class="extra">
            <h3>其他信息</h3>
            <p><span class="title"><span class="neccessary">*</span>联系人</span><input type="text" name="connector" class="connector"></p>
            <p><span class="title">QQ</span><input class="qq" type="text" name="QQ"></p>
            <p><span class="title">身份选择</span><input class="id" type="text" name="id"></p>
            <p><span class="title"><span class="neccessary">*</span>联系电话</span><input type="text" class="phone" name="phone"></p>
          </div>
          <p class="care-wrap"><span class="title"></span><input class="care" type="checkbox">公布真实号码，电话隐私不受保护</p>
          <p><span class="title"></span><button type="button" @click="publish" class="publish">发布</button></p>
        </form>
      </div>
    </section>
    <modal :showModal="showModal"></modal>
  </div>
</template>

<script>
import LoginNavigator from "../../../components/LoginNavigator";
import PublishNav from "../../../components/PublishNav";
import PublishStatus from "../../../components/PublishStatus";
import Modal from "../../../components/Modal";
export default {
  data() {
    return {
      navStatus: 1,
      showModal: false
    };
  },

  components: {
    LoginNavigator,
    PublishNav,
    PublishStatus,
    Modal
  },
  methods: {
    publish: function() {
      console.log("发布");
      this.showModal = true;
      console.log(this.showModal);
    }
  }
};
</script>
<style scoped>
select {
  font-size: 16px;
}
.container {
  background: #f5f5f5;
}
.main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}
.main .main-content {
  padding: 47px 0 0 200px;
}
.main .main-content p {
  margin: 39px 0;
}
.main .main-content .neccessary {
  color: red;
}
.main .main-content .title {
  display: inline-block;
  width: 100px;
  height: 20px;
  line-height: 20px;
  text-align: right;
  font-size: 16px;
  color: #808080;
  margin-right: 30px;
}
.main .main-content .name,
.startTime,
.peopleNum,
.tit,
.id,
.connector,
.qq,
.phone {
  height: 40px;
}
.main .main-content .id,
.connector,
.qq,
.phone {
  width: 280px;
}
.main .main-content .tit {
  width: 420px;
}
.main .main-content input {
  font-size: 16px;
  color: #b3b3b3;
}
.main .main-content .introduce-wrap {
  display: flex;
  align-items: center;
}
.main .main-content .care {
  width: 16px;
  height: 16px;
}
.main .main-content .publish {
  display: inline-block;
  text-align: center;
  width: 260px;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #00a0e9;
  border: none;
  font-size: 16px;
}
.main .main-content .care-wrap {
  display: flex;
  align-items: center;
}
.main .main-content .basic .home-des {
  display: flex;
  flex-direction: row;
  padding-bottom: 39px;
}
.main .main-content .basic .home-des .home-title {
  /* display: inline-block; */
  flex: none;
  text-align: right;
  width: 100px;
  height: 20px;
  line-height: 20px;
  margin-top: 10px;
}
.main .main-content .home-des .home-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
}
.left-absolute {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5px;
}
.main .main-content .home-des .home-wrap {
  margin-left: 30px;
}
.main .main-content .home-des .home-wrap input,
select {
  box-sizing: border-box;
  width: 180px;
  height: 40px;
}
.main .main-content .home-des .home-wrap input {
  margin-left: 19px;
}
.main .main-content .home-des .home-wrap .room {
  margin-left: 0;
}
.main .main-content .home-des .home-wrap select {
  margin: 28px 19px 0 0;
}
.main .main-content .floor-wrap,
.main .main-content .parking-wrap,
.main .main-content .money-wrap,
.main .main-content .fee-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.main .main-content .fee-wrap {
  align-items: flex-start;
}
.main .main-content .floor-wrap > span:first-child {
  display: inline-block;
  text-align: right;
  width: 100px;
  height: 20px;
  line-height: 20px;
}
.main .main-content .parking-wrap span:first-child {
  display: inline-block;
  text-align: right;
  width: 100px;
  height: 20px;
  line-height: 20px;
}
.main .main-content .money-wrap span:first-child {
  display: inline-block;
  text-align: right;
  width: 100px;
  height: 20px;
  line-height: 20px;
}
.main .main-content .fee-wrap span:first-child {
  display: inline-block;
  text-align: right;
  width: 110px;
  height: 20px;
  line-height: 20px;
}
.main .main-content .parking-wrap,
.main .main-content .money-wrap,
.main .main-content .fee-wrap {
  margin-top: 39px;
}
.main .main-content .fee-wrap {
  margin-bottom: 39px;
}
.main .main-content .parking-wrap .parking-des {
  margin-left: 30px;
}
.main .main-content .floor-wrap .floor-des,
.main .main-content .money-wrap .money-des,
.main .main-content .fee-wrap .fee-des {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 30px;
}
.main .main-content .floor-wrap .floor-des .absolute,
.main .main-content .money-wrap .money-des .absolute {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 25px;
}
.main .main-content .floor-wrap input,
.main .main-content .money-wrap input {
  box-sizing: border-box;
  width: 180px;
  height: 40px;
  margin-right: 19px;
}

.main .main-content .fee-wrap .fee-item {
  margin: 0 0 27px 65px;
}
.main .main-content .fee-wrap .fee-des .fee-item:first-child {
  margin-left: 0;
}
.main .main-content .fee-wrap .fee-des .fee-item:last-child {
  margin-left: 0;
}
.main .main-content .radio_label {
  margin-right: 29px;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/publishItem/Home.vue